<template>
    <div v-if="$store.state.websiteDataLoaded">
        <section class="main blog" v-animate.fade="'slide-left'">
            <div class="cg">
                <h1>
                   Blog
                </h1>
            </div>
            <div class="inner cg">
                <div class="content blog-news-list">
                    <div class="inline-warp">
                        <div v-bind:key="key" v-for="(blogPost, key) in $store.state.websiteData.blog_posts" class="inline-3">
                            <router-link :to="`/blog/${ blogPost.slug }`" class="clickable">
                                <div class="logo"  v-bind:style="{
                                  backgroundImage: 'url(\''+  blogPost.image + '\')',
                                  backgroundPosition: 'center',
                                  backgroundSize: 'cover'
                               }"></div>
                            </router-link>
                            <label>
                                <h2 class="clickable" :data-url="`/blog/${ blogPost.slug }`">{{ blogPost.title }}</h2>
                                <h5>{{ blogPost.published_at | formatDate }}</h5>
                            </label>
                            <span class="text">
                                {{ blogPost.excerpt }}..
                            </span>
                            <router-link :to="`/blog/${ blogPost.slug }`" class="read-more" >Read more &gt;&gt;</router-link>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <contact/>
    </div>
</template>

<script>
    import Contact from '@/components/contact-bar';

    export default {
        components: { Contact },
        computed: {},
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/mixins.scss';

    .main {
        padding: 40px 0;
    }

    h1 {
        font-weight: 400;
    }

    .info {
        position: relative;
        padding: 40px 0;
        background: #f9f9f9;
        z-index: 1;

        &:before {
            content: '';
            background: url('../../assets/citizenship/bg.png') no-repeat;
            width: 1209px;
            max-width: 100vw;
            height: 605px;
            top: -180px;
            left: 50%;
            transform: translateX(-50%);
            position: absolute;
        }

        p {
            @include desktop {
                padding-right: 550px;
            }
        }

        .inner {
            position: relative;

            &:after {
                width: 550px;
                height: 501px;
                background: url('../../assets/citizenship/1.png') no-repeat;
                position: absolute;
                right: 0;
                top: -100px;

                @include desktop {
                    content: '';
                }
            }
        }
    }

    .list {
        background: #eff8fe;

        @include mobile {
            padding: 40px 0;
        }

        @include desktop {
            padding: 80px 0;
        }

        h1 {
            font-weight: normal;
        }
    }

    .content.blog-news-list .inline-warp .inline-3 {
        width: calc(33.3333% - 30px);
        margin-right: 45px;
        margin-top: 40px;
        margin-bottom: 5px;
        padding-bottom: 45px;
        position: relative;

        @media(max-width: 768px){
            width: 100%;
        }
    }

    .content.blog-news-list .inline-warp .inline-3:nth-child(3n) {
        margin-right: 0;
    }

    .content.blog-news-list .inline-warp .inline-3 .logo {
        width: 100%;
        height: 240px;
        display: block;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
    }

    .content.blog-news-list .inline-warp .inline-3 label {
        min-height: 60px;
        font-size: 16px;
        margin-top: 20px;
        display: block;
        padding: 0 10px 0 10px;
        border-left: 3px solid #83ca54;
    }

    .content.blog-news-list .inline-warp .inline-3 label h1 {
        font-size: 18px;
        color: #1e2b34;
        font-weight: 700;
        line-height: 22px;
        cursor: pointer;
    }

    .content.blog-news-list .inline-warp .inline-3 label h5 {
        font-size: 14px;
        font-weight: 400;
        color: #b4b4b4;
        line-height: 14px;
        margin-top: 10px;
    }

    .content.blog-news-list .inline-warp .inline-3 .text {
        display: block;
        padding: 12px 10px 0 14px;
        font-size: 90%;
        font-weight: 300;
        color:  #374d5c;
    }

    .content.blog-news-list .inline-warp .inline-3 a.read-more {
        position: absolute;
    }
    .content.blog-news-list .inline-warp .inline-3 a {
        bottom: 10px;
        font-weight: 500;
        font-size: 16px;
        color: #83ca54;
        left: 14px;
    }

    .content.blog-news-list .inline-warp .inline-3 a:hover {
        text-decoration: underline;
    }

    .content.blog-news-list .but {
        margin: 25px auto 0;
        display: inline-block;
    }

    .but {
        padding: 15px;
        border-radius: 5px;
        box-shadow: none;
        border: none;
        font-size: 14px;
        font-weight: 700;
        color: #4d5e6b;
        background: #fff;
        display: block;
        cursor: pointer;
        display: inline-block;
        text-transform: uppercase;
    }

    .but.but-green {
        color: #ffffff;
        background: #8aa203;
        -webkit-transition: 0.5s;
        transition: 0.5s;
    }

    .but.but-green:hover {
        color: #ffffff;
        background: #bbd433;
    }

    .inline-warp .inline-3 {
        width: 33.3333%;
        display: inline-block;
        vertical-align: top;
    }

    .blog h2 {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0 !important;
        font-size: 100%;
        vertical-align: baseline;
        background: transparent;
        line-height: 20px;
    }
</style>